import React from 'react'
import Icon from 'react-icon-base'

export default props => {
  return (
    <Icon viewBox="0 0 90.9 100" {...props}>
      <title id="Polygon">{props.title || 'Polygon'}</title>
      <g>
        <path d="M90.6 42.7v-26.5h-26.5v9.2l-26.7-7.3v-16.8h-26.4v26.5h11.3l-6.7 44.5h-15.3v26.5h26.5v-13.9l30.7-1.3v12.3h26.5v-26.5h-11.4l3.3-26.7h14.7zm-70.5 49.3h-13.1v-13.1h13.1v13.1zm10.7-70.9h-13.1v-13.1h13.1v13.1zm46.5 55v13.1h-13.1v-13.1h13.1zm-6.3-40.1v-13.1h13.1v13.1h-13.1z" />
      </g>
    </Icon>
  )
}



// WEBPACK FOOTER //
// ./client/components/icons/polygon.js